/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2MedicalTaskIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2MedicalTaskIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2MedicalTaskIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 19,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#34126F"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2MedicalTaskIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 19"
 style={{'--as-1-1uWCqU': alignSelf,'--mt-2-1uWCqU': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1uWCqU': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1uWCqU': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1uWCqU': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1uWCqU': opacity,'--w-10-1uWCqU': typeof width === 'number' ? `${width}px` : width,'--h-11-1uWCqU': typeof height === 'number' ? `${height}px` : height,'--f-12-1uWCqU': fill,'--a-7-1uWCqU': isAnimated ? animation : "none",'--sd-8-1uWCqU': isAnimated ? strokeDashoffset : 0,'--sd-9-1uWCqU': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2MedicalTaskIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.586.596A1.982 1.982 0 012 0h8a.66.66 0 01.471.199l5.334 5.428c.125.128.195.3.195.48v10.857c0 .54-.21 1.058-.586 1.44A1.983 1.983 0 0114 19H2c-.53 0-1.04-.214-1.414-.596A2.054 2.054 0 010 16.964V2.036C0 1.496.21.978.586.596zm6.041 6.77c0-.294.234-.533.523-.533h1.7c.289 0 .523.239.523.533v2.117h2.08c.29 0 .524.239.524.533v1.73a.528.528 0 01-.524.533h-2.08v2.117a.528.528 0 01-.523.533h-1.7a.528.528 0 01-.523-.533V12.28h-2.08a.528.528 0 01-.524-.533v-1.73c0-.294.235-.533.524-.533h2.08V7.366z"
 style={{'--f-12-1uWCqU': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}